export enum RumEvents {
  USER_ALIAS = 'custom_event.user_alias',
}
